<template>
    <div class="com">
        <iframe class="frame" :src="src" frameborder="0" id="iframe"></iframe>
    </div>
</template>

<script>
    import { globalConfig } from "static/config"

    export default {
        data() {
            return {}
        },
        mounted() {
            const oIframe = document.getElementById("iframe");
            const deviceWidth = document.documentElement.clientWidth;
            const deviceHeight = document.documentElement.clientHeight;
            oIframe.style.width = Number(deviceWidth) - 180 + "px"; //数字是页面布局宽度差值
            oIframe.style.height = Number(deviceHeight) - 55 + "px"; //数字是页面布局高度差
        },
        computed: {
            src() {
                return globalConfig.EAM_URL + "/form/registerScoreQuery/xnxqzpcx.jsp";
            }
        }
    };
</script>
<style scoped>
    .com {
        height: auto;
    }

    .frame {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// tempSemesterScore.vue?475e41ec